import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { StateType } from "../../../../utils/types";
import {
  deleteOnboarding,
  getOnboardingById,
} from "../../../../redux/educator/actions";
import { selectOnboarding } from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  onboarding: selectOnboarding(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getOnboardingById,
      deleteOnboarding,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
